module.exports = __webpack_public_path__ + "images/volvocarlease_small8a74e35de8233074a6811ac0af633a52.png";